import React from 'react'
import './footer.css'
import Wave from '../wave/Wave'
import { useTour } from '../tour/TourContext'
import { INSTAGRAM_URL, SCHOOL_EMAIL, SCHOOL_PHONE, SCHOOL_PHONE_LINK } from '../../config'
import logo from '../../assets/LIM_STACKEDV1.png'
import NAClogo from '../../assets/NAC Logo.png'
import goalseal from '../../assets/goldseal.png'
import schoolreadiness from '../../assets/SchoolReadiness.jpg'

export default function Footer() {
  const { openRequest } = useTour()

  return (
    <footer className="footer-container">
      <Wave color="var(--lavender)" up />
      <div className="footer-list">
        <div className="footer footer-brand">
          <img className='footer-logo' src={logo} alt="Learning In Motion Logo"/>
          <a
            className='footer-instagram'
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            aria-label="Learning In Motion Academy on Instagram"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" fill="currentColor" aria-hidden="true">
              <path d="M12 2.2c3.2 0 3.6 0 4.9.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s0 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58 0-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.21 15.58 2.2 15.2 2.2 12s0-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.21 8.8 2.2 12 2.2Zm0 1.62c-3.15 0-3.52.01-4.76.07-.9.04-1.39.19-1.71.32-.43.17-.74.37-1.06.69-.32.32-.52.63-.69 1.06-.13.32-.28.81-.32 1.71-.06 1.24-.07 1.61-.07 4.76s.01 3.52.07 4.76c.04.9.19 1.39.32 1.71.17.43.37.74.69 1.06.32.32.63.52 1.06.69.32.13.81.28 1.71.32 1.24.06 1.61.07 4.76.07s3.52-.01 4.76-.07c.9-.04 1.39-.19 1.71-.32.43-.17.74-.37 1.06-.69.32-.32.52-.63.69-1.06.13-.32.28-.81.32-1.71.06-1.24.07-1.61.07-4.76s-.01-3.52-.07-4.76c-.04-.9-.19-1.39-.32-1.71a2.86 2.86 0 0 0-.69-1.06 2.86 2.86 0 0 0-1.06-.69c-.32-.13-.81-.28-1.71-.32-1.24-.06-1.61-.07-4.76-.07Zm0 2.76a5.42 5.42 0 1 1 0 10.84 5.42 5.42 0 0 1 0-10.84Zm0 1.62a3.8 3.8 0 1 0 0 7.6 3.8 3.8 0 0 0 0-7.6Zm5.6-2.9a1.27 1.27 0 1 1 0 2.54 1.27 1.27 0 0 1 0-2.54Z"/>
            </svg>
            <span>Follow along</span>
          </a>
        </div>

        <div className="footer">
          <h3>Contact Us</h3>
          <a className='footer-number' href={SCHOOL_PHONE_LINK}>{SCHOOL_PHONE}</a>
          <h4>Director, Stephanie Meza</h4>
          <a className='footer-email' href={`mailto:${SCHOOL_EMAIL}`}>{SCHOOL_EMAIL}</a>
          <h3 className="footer-subhead">Visit Us</h3>
          <h4>6820 NW 70th Ave, Tamarac, FL, 33321</h4>
          <h4>School Hours: 6:30am - 6:30pm</h4>
          <button type="button" className="btn btn-pink footer-cta" onClick={openRequest}>
            Schedule a Tour
          </button>
        </div>

        <div className="footer">
          <div className='footer-map'>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1064.2408061738806!2d-80.24537356927368!3d26.20756996887327!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d905b8485f5b01%3A0x7366d88ba84cd55b!2sLearning%20In%20Motion%20Academy!5e0!3m2!1sen!2sus!4v1689363192423!5m2!1sen!2sus"
            title="footer map"
            className="googlemap"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </div>
      </div>

      <div className='footer-badges'>
        <img className='nac-logo' src={NAClogo} alt="Asssociation For Early Learning Leaders"/>
        <img className='school-readiness' src={schoolreadiness} alt="School Readiness"/>
        <img className='goalseal-logo' src={goalseal} alt="Florida Quality Care Gold Seal" />
      </div>

      <p className="footer-license">License #46713</p>
      <h4 className="copyright">Learning In Motion Academy, Inc. ©</h4>
    </footer>
  )
}
